<template>
  <b-container class="login">
    <b-row align-h="center">
      <h1 class="login__title">
        Welcome to EMS Dashboard
      </h1>
    </b-row>
    <b-row align-h="center">
      <h3>Sign in to continue</h3>
    </b-row>
    <b-row align-h="center" class="login__panel">
      <b-col cols="6">
        <b-alert id="login__error-required" :show="!!errorMessage" variant="danger">{{ errorMessage }}</b-alert>
        <b-form id="login__form" @submit.prevent="onSubmit()">
          <b-form-group
            label="Email or username:"
            label-for="login__username-or-email"
            :invalid-feedback="usernameFieldFeedback"
          >
            <b-form-input
              id="login__username-or-email"
              v-model="form.username"
              type="text"
              :state="isUsernameValid"
              @input="onType()"
            />
          </b-form-group>
          <b-form-group label="Password" label-for="login__password" :invalid-feedback="passwordFieldFeedback">
            <b-form-input
              id="login__password"
              v-model="form.password"
              type="password"
              :state="isPasswordValid"
              @input="onType()"
              @keyup.enter="onSubmit()"
            />
          </b-form-group>

          <b-button v-show="!isLoading" id="login__signin-button" variant="primary" @click.prevent="onSubmit()">
            Sign in
          </b-button>

          <b-button v-show="isLoading" id="login__signin-loading-indicator" variant="primary" disabled>
            <b-spinner small />
            Signing in...
          </b-button>

          <div class="password-reset-link">
            <b-link :href="passwordResetUrl" target="_blank">
              <span>Reset Password</span>
            </b-link>
          </div>
        </b-form>
      </b-col>
    </b-row>
    <br />
    <ContactInfo />
  </b-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import config from "@/App/config";
import ContactInfo from "@/App/components/ContactInfo.vue";

export default {
  name: "Login",
  components: { ContactInfo },
  data() {
    return {
      form: {
        username: "",
        password: ""
      }
    };
  },
  computed: {
    ...mapState("Login", ["usernameError", "passwordError", "errorMessage", "isLoading"]),
    isUsernameValid() {
      return this.usernameError ? false : null;
    },
    usernameFieldFeedback() {
      return this.usernameError;
    },
    isPasswordValid() {
      return this.passwordError ? false : null;
    },
    passwordFieldFeedback() {
      return this.passwordError;
    },
    passwordResetUrl() {
      return `${config.RESET_PASSWORD_URL}/password/forgot?return-url=${window.location.href}`;
    }
  },
  methods: {
    ...mapActions("Login", ["login"]),
    onSubmit() {
      this.login(this.form);
    },
    onType() {
      this.$store.commit("Login/CLEAR_ERRORS");
    }
  }
};
</script>

<style scoped>
.login__title {
  margin-top: 1em;
}

.login__panel {
  margin-top: 4em;
}

.password-reset-link {
  margin-top: 1em;
}
</style>
